
import ContainerPage from '../../components/ContainerPage'

import { useHistory } from 'react-router-dom'
import { useState } from 'react'
import { useData } from '../../Context/DataContext'

function Nomeacao2(){
    const history = useHistory()
    const [dados, setDados] = useState({
        quantidadeMemoria: 0
    })

    const handleChange = (event) => {
        setDados({
            ...dados,
            [event.target.name]: event.target.value
        })
    }

    const data = useData()

    const next = (e) => {

        // data.setData({
        //     ...data,
        //     quantidadeMemoria: dados.quantidadeMemoria,
        //     quantidadeMemoria2: dados.quantidadeMemoria2,
        // })

        const newData = {
            ...(data.data),
            ...dados
        }

        data.setData(newData)

        history.push('/nomeacao3')
    }

    return (
        <ContainerPage>
            <div className="row">
                <div className="col mt-1 mb-5">
                    <h3 className="text-center mb-4"><strong>Identificação e Nomeação de Figuras</strong></h3>

                    <form>
                        

                        <p>
                            Terminada a nomeação, esconda a figura e pergunte:
                        </p>

                        <ul>
                            <li>Que figuras eu acabei de mostrar?</li>
                        </ul>
                        <small>O número de itens evocados fornece o escore de memória incidental.</small><br/>
                        <input type={"number"} className="form-control" name='quantidadememoria' onChange={handleChange} value={dados.quantidadememoria} />

                        <div className="form-group text-center mt-3">
                            <button className="btn btn-default" type="button" onClick={next}>Próximo</button>
                        </div>
                    </form>
                </div>
            </div>
        </ContainerPage>
    )
}

export default Nomeacao2